import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "base-info js-base-info" }
const _hoisted_2 = { class: "base-info__item-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.label,
        class: "base-info__item"
      }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(item.label) + ":", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["base-info__item-value", { 'base-info__item-value_loading': item.isLoading }])
        }, _toDisplayString(_ctx.getValue(item.value)), 3)
      ]))
    }), 128))
  ]))
}